/* eslint-disable unicorn/filename-case -- a hook is not a component, and this package's rule assumes one */
import { isIntegralQuantityViolation } from '@nudool/shared';
import * as React from 'react';

/** Shared validation logic for quantity inputs on integral UOMs. Use this when DimeQuantityInput cannot be used directly (e.g. inside DimeInputGroup). */
export function useDimeQuantityValidation(
  value: string | number | readonly string[] | undefined | null,
  integral: boolean,
): { isViolating: boolean; errorId: string } {
  const errorId = React.useId();
  const isViolating = isIntegralQuantityViolation(value, integral);

  return { isViolating, errorId };
}
